import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import ApplicationCompletePage from './ApplicationCompletePage';

const ApplicationCompleteSection = ({ bankId, offer, getCorpAdminUrl }) => (
  <ApplicationCompletePage
    bankId={bankId}
    offer={offer}
    saveApplicationCompleteForm={() => {
      window.open(getCorpAdminUrl, '_blank');
    }}
  />
);

ApplicationCompleteSection.propTypes = {
  bankId: PropTypes.bankId,
  saveApplicationCompleteForm: PropTypes.func.isRequired
};

const actionCreators = {};

const mapStateToProps = state => ({
  bankId: selectors.bankId(state),
  getCorpAdminUrl: selectors.getCorpAdminUrl(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationCompleteSection);
